<template>
  <div class="persion">
    <van-nav-bar
      class="barColor"
      :title="$t('邮箱')"
      :right-text="$t('提交')"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div class="persion-card">
      <div class="email">{{ $t('请填写你的邮箱') }}</div>
    </div>
    <div class="persion-card">
      <van-form @submit="onClickRight" ref="form">
        <van-field
          v-model="email"
          class="nameText"
          :rules="[
            {
              pattern:
                /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
              message: $t('邮箱地址格式不正确！'),
            },
          ]"
        />
      </van-form>
    </div>
  </div>
</template>
<script>
import { Field, Icon, Divider, NavBar, Form, Toast } from 'vant'
import Vue from 'vue'
import { postUserInfo, queryStaffToekn } from '@/services/api'
Vue.use(Icon)
Vue.use(Field)
Vue.use(Divider)
Vue.use(NavBar)
Vue.use(Form)
Vue.use(Toast)

export default {
  name: 'PersionalEmail',
  components: {
    NavBar,
  },
  data() {
    return {
      email: '',
      user: {},
      roleId: '',
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async onClickRight() {
      let params = {}
      if (this.email === '') {
        this.email = '' // 将邮箱值设置为空字符串
      } else {
        const isValid = await this.$refs.form.validate()
        params = { name: this.email } // 设置name参数为邮箱值
      }
      await this.postUserInfo() // 更新用户信息
      this.$router.push({
        path: '/persionInfo',
        params: params, // 使用params传递参数
        query: { refresh: true },
      })
      Toast(this.$t('修改成功'))
    },
    async postUserInfo() {
      this.user = JSON.parse(localStorage.getItem('user'))
      let newUser = await queryStaffToekn({ token: this.user.token })
      this.roleId = newUser.roleList.map((item) => item.id).join(',')
      this.user.email = this.email // 更新 user 对象中的 email 属性
      await postUserInfo({
        id: this.user.id,
        email: this.email,
        companyId: this.user.companyId,
        roleId: this.roleId,
        facePhoto: newUser.facePhoto || '',
      })
      localStorage.setItem('user', JSON.stringify(this.user)) // 存储更新后的user对象
      this.$router.push({
        params: { email: this.email }, // 将更新后的姓名作为参数传递给下面的页面
      })
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
  },
}
</script>
<style lang="less" scoped>
.van-nav-bar {
  background: #00bdff;
}
.persion /deep/ .van-nav-bar__title {
  color: white !important;
  font-size: 16px;
}
.persion /deep/ .van-nav-bar .van-icon {
  color: white !important;
}

.persion /deep/ .van-nav-bar__text {
  color: white !important;
}

.persion {
  height: 100%;
  .persion-card {
    height: 70px;
    padding: 0px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fefffe;
    font-size: 16px;
    line-height: 24px;
    border-bottom: 1px solid #ebebeb;

    .email {
      font-weight: bold;
    }
  }
}
</style>
